// extracted by mini-css-extract-plugin
module.exports = {"title":"Documents_title__3Vxzj","selects":"Documents_selects__1i0Nl"};